import '@mdi/font/css/materialdesignicons.css'; // Ensure you are using css-loader
import {
    ContentElement,
    createStore,
    FileUpload,
    FormGridRow,
    FormVue,
    HiddenfieldHoneypot,
    OnCaptcha,
    OnCheckBox,
    OnRadioGroup,
    OnSelect,
    OnTextArea,
    OnTextfieldEmail,
    OnTextfieldNumber,
    OnTextfieldText,
    registerResponseInterceptor,
    StaticText,
    Telephone
} from 'formvue-json';

import SubmitButton from './components/submit_button.vue';

import Vue from 'vue';
import Vuex from 'vuex';
import Vuetify from 'vuetify/lib/framework';

// configure Vue
Vue.use(Vuex);
Vue.use(Vuetify);


export default function initFormVue() {
    const forms = document.querySelectorAll('[data-id]');
    const formConfigsList = window.extendedforms;
    const formViews = {};

    if (!formConfigsList) return formViews;

    // create vuetify config
    const vuetifyConfig= {
        icons: {
            iconfont: 'mdi'
        },
        theme: {
            dark: false,
            themes: {
                light: {
                    primary: "#008195",
                    accent: "#dae5f4",
                    error: "#FF1F00"
                }
            }
        }
    }

    // intercept for Mailchimp response
    registerResponseInterceptor((context, json) => {
        // Mailchimp finisher responses have the 'success' attribute set
        if ('success' in json) {
            context.commit('setFormResponse', {
                error: !json.success,
                html: json.content
            });
            context.commit('setLoading', false);
            return true; // cancel response pipeline
        }

        if(json.status<400){
            const forms=document.querySelectorAll('#formvue-kontakt-55, #formvue-kontakt_en-862');
            forms.forEach(element=>{
                let nextElement=element.nextElementSibling;
                if(nextElement){
                    nextElement.remove();
                }
            })
        }

        return false;
    });


    const callbacks = {
        MatomoTracking: async(cbArgs)=>{  // can this be removed?
            console.log(cbArgs);
            if(!cbArgs || !cbArgs.goal) return console.warn("[MatomoTracking] could not find key goal in arguments")
            SDS.Utils.trackMatomoGoal(cbArgs.goal);
        },
        GoogleAnalytics: async (cbArgs) => {
            if (!cbArgs) {
                console.warn('[GoogleAnalytics] could not find arguments');
                return;
            }

            // validate existing
            if (!['event', 'form_id', 'currency', 'value'].every(key => {
                const val = cbArgs[key];
                if (!val || typeof(val) !== 'string' || val.length <= 0) {
                    console.warn(`[GoogleAnalytics] could not find '${key}' argument`);
                    return false;
                }
                return true;
            })) return;

            let {event, form_id, currency, value} = cbArgs;

            // parse number and validate
            value = parseInt(value);
            if (isNaN(value)) {
                console.warn('[GoogleAnalytics] could not determine value');
                return;
            }

            // fire the GoogleAnalytics event
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': event,
                'form_id': form_id,
                'currency': currency,
                'value': value
            });
        }
    }

    for (let form of forms) {
        const id = form.getAttribute('data-id');
        const wrapper = document.querySelector('[data-id="' + id + '"]');

        if (!wrapper) continue;
        const formSchema = formConfigsList[id];
        if (!formSchema || !formSchema.configuration) continue;


        const vueInstance = new Vue({
            vuetify: new Vuetify(vuetifyConfig),
            store: createStore(Vuex, {
                formData: formSchema,
                callbacksMap: callbacks
            }),
            render: h => h(FormVue, {
                props: {
                    formSchema,
                    componentsMap: {
                        Text: OnTextfieldText,
                        Email: OnTextfieldEmail,
                        Number: OnTextfieldNumber,
                        Honeypot: HiddenfieldHoneypot,
                        Checkbox: OnCheckBox,
                        LinkedCheckbox: OnCheckBox,
                        SingleSelect: OnSelect,
                        FileUpload: FileUpload,
                        StaticText: StaticText,
                        Textarea: OnTextArea,
                        Oncaptcha: OnCaptcha,
                        Telephone: Telephone,
                        GridRow: FormGridRow,
                        ContentElement: ContentElement,
                        RadioButton: OnRadioGroup,
                        SubmitButton: SubmitButton
                    },
                    fieldPropsOverwrite: {
                        filled: true // force all vuetify inputs to be variant=filled
                    },
                    showErrorResponseInsideForm: true
                }
            })
        }).$mount(wrapper);

        formViews[id] = vueInstance;

    }
    return formViews;
}


initFormVue();

